import React from "react";

function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        <p style={styles.message}>{message}</p>
        <div style={styles.buttons}>
          <button style={styles.confirmBtn} onClick={onConfirm}>Evet</button>
          <button style={styles.cancelBtn} onClick={onCancel}>İptal</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  box: {
    backgroundColor: "#fff",
    padding: "20px 30px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 6px 20px rgba(0,0,0,0.25)"
  },
  message: {
    fontSize: "18px",
    marginBottom: "20px"
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem"
  },
  confirmBtn: {
    padding: "8px 16px",
    backgroundColor: "#e3342f",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer"
  },
  cancelBtn: {
    padding: "8px 16px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer"
  }
};

export default ConfirmModal;
